import { render } from "./FilterRegion.vue?vue&type=template&id=1743915c&ts=true"
import script from "./FilterRegion.vue?vue&type=script&lang=ts"
export * from "./FilterRegion.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__